var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FontIcon',{staticClass:"lu-click ",attrs:{"type":"material-icons","name":"fullscreen","size":"xlarge"},on:{"click":_vm.click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }